import { Disposable } from "../../../js/util/Disposable";
import { AssetPack } from "./loader/asset-loader";
import { Container, Renderer } from "pixi.js";
import Platform from "./platform/platform";
import StageSystem from "./platform/stage";
import MouseSystem from "./platform/mouse";
import PointerSystem from "./platform/pointer";
import KeyboardSystem from "./platform/keyboard";
import { World } from "ecsy";

export class Engine implements Disposable {
  public assetpack: AssetPack;
  constructor(
    canvas: HTMLCanvasElement,
    width: number,
    height: number,
    assetpack: AssetPack
  ) {
    if (Engine._instance != null) {
      throw "The engine has already been instantiated";
    }
    Engine._instance = new Platform(canvas, width, height);

    this.assetpack = assetpack;
    Engine.renderer.backgroundColor = 0xffffff;
  }

  /**
   *
   * @param width The width of the viewport for this game
   * @param height The height of the viewport for this game
   */
  resize(width: number, height: number) {
    Engine.renderer.resize(width, height);
  }

  dispose() {
    if (Engine._instance === null) {
      throw "The platform is not instantiated";
    }
    return Engine._instance.destroy();
  }

  static reset(): void {
    if (Engine._instance === null) {
      throw "The platform is not instantiated";
    }
    return Engine._instance.reset();
  }

  static get renderer(): Renderer {
    if (Engine._instance === null) {
      throw "The platform is not instantiated";
    }
    return Engine._instance.renderer;
  }

  static get stage(): StageSystem {
    if (Engine._instance === null) {
      throw "The platform is not instantiated";
    }
    return Engine._instance.stage;
  }

  static get world(): World {
    if (Engine._instance === null) {
      throw "The platform is not instantiated";
    }
    return Engine._instance.world;
  }

  static get mouse(): MouseSystem {
    if (Engine._instance === null) {
      throw "The platform is not instantiated";
    }
    return Engine._instance.mouse;
  }

  static get pointer(): PointerSystem {
    if (Engine._instance === null) {
      throw "The platform is not instantiated";
    }
    return Engine._instance.pointer;
  }

  static get container(): Container {
    if (Engine._instance === null) {
      throw "The platform is not instantiated";
    }
    return Engine._instance.container;
  }

  static get keyboard(): KeyboardSystem {
    if (Engine._instance === null) {
      throw "The platform is not instantiated";
    }
    return Engine._instance.keyboard;
  }

  private static _instance: Platform | null;
}
